export const AutoSelect = {
  mounted() {
    this.el.select();
  },
};
